module.exports = __webpack_public_path__ + "static/img/img_bg_dl.c0b647f.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/img_bg_dl.png
// module id = xKOD
// module chunks = 83